type Props = {
  fill?: string;
  height: string;
  width: string;
};

const VectorIcon = ({ fill = 'black', width, height }: Props) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.322887 9.67711C-0.107629 9.2466 -0.107629 8.54859 0.322887 8.11807L8.11807 0.322887C8.54859 -0.107629 9.2466 -0.107629 9.67711 0.322887C10.1076 0.753404 10.1076 1.45141 9.67711 1.88192L1.88192 9.67711C1.45141 10.1076 0.753404 10.1076 0.322887 9.67711Z"
          fill={fill}
        />
        <path
          d="M9.67711 9.67711C9.2466 10.1076 8.54859 10.1076 8.11807 9.67711L0.322887 1.88192C-0.107629 1.45141 -0.107629 0.753404 0.322887 0.322887C0.753404 -0.107629 1.45141 -0.107629 1.88192 0.322887L9.67711 8.11807C10.1076 8.54859 10.1076 9.2466 9.67711 9.67711Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default VectorIcon;
